/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskQueuesAddonViewType from '@jira/spa-apps__servicedesk-queues-addon-view/src/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';

export const LazyServicedeskQueuesAddonView: LazyComponent<typeof ServicedeskQueuesAddonViewType> =
	lazyForPaint<typeof ServicedeskQueuesAddonViewType>(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-queues-addon-view", jiraSpaEntry: "async-servicedesk-queues-addon-view" */ '@jira/spa-apps__servicedesk-queues-addon-view/src/index.tsx'
			),
	);

type Props = RouteContext;

const AsyncServicedeskQueuesAddonView = ({ match }: Props): React.JSX.Element => {
	const addonKey = (match.params && match.params.addonKey) || '';
	return (
		<LazyPage
			Page={LazyServicedeskQueuesAddonView}
			pageId={`spa-apps/servicedesk/queues/addon/${addonKey}`}
			shouldShowSpinner
		/>
	);
};

export default AsyncServicedeskQueuesAddonView;
